var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M13.343 4.177H22.904V19.794H13.343z",
    transform: "translate(-1090 -388) translate(420 305) translate(0 65) translate(668 16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M14.328 11.986c-.002-3.047 1.397-5.925 3.793-7.807C14.05.98 8.202 1.445 4.69 5.25c-3.513 3.805-3.513 9.67 0 13.475 3.513 3.805 9.36 4.27 13.432 1.07-2.397-1.88-3.796-4.76-3.793-7.809z",
    transform: "translate(-1090 -388) translate(420 305) translate(0 65) translate(668 16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M33.241 18.14v-.32h.138v-.066h-.328v.067h.13v.32h.06zm.638 0v-.386h-.1l-.116.276-.115-.276h-.1v.387h.072v-.293l.108.251h.074l.108-.25v.292h.069zM34.19 11.986c0 3.803-2.17 7.271-5.59 8.933-3.42 1.661-7.49 1.224-10.479-1.126 2.396-1.883 3.795-4.761 3.795-7.808 0-3.047-1.399-5.926-3.795-7.808 2.99-2.35 7.058-2.788 10.478-1.126s5.591 5.13 5.591 8.932v.003z",
    transform: "translate(-1090 -388) translate(420 305) translate(0 65) translate(668 16)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.a61ae2061b2bce5ac7ff3fca453c3ad9.svg";
export { ForwardRef as ReactComponent };